export const ApiURL = "https://api.lajungle.net";


/** WEBPACK FOOTER **
 ** ./src/api/config.prod.js
 **/